export default __webpack_public_path__ + "static/media/MiniExtensions.07959141.png";